import {RouteRecordRaw} from 'vue-router'
import HomeProgetti from "@/views/HomeProgetti.vue";
import ListaFornitori from "@/views/ListaFornitori.vue";
import DettaglioFornitore from "@/views/DettaglioFornitore.vue";
import NuovoFornitore from "@/views/NuovoFornitore.vue";
import FornitoriMenu from "@/components/FornitoriMenu.vue";
import FornitoreAudit from "@/views/Fornitore/FornitoreAudit.vue";

const fornitoriRoutes: Array<RouteRecordRaw> = [
    {
        path: '/fornitori/',
        meta: {'app': 'for'},
        components: {
            default: HomeProgetti,
            nav: FornitoriMenu,
        },
        props: true,
        children: [
            {
                path: '',
                name: 'ListaFornitori',
                component: ListaFornitori,
            },
            {
                path: 'nuovo-fornitore',
                name: 'NuovoFornitore',
                component: NuovoFornitore,
            },
            {
                path: ':fid/',
                name: 'DettaglioFornitore',
                component: DettaglioFornitore,
                props: true
            },
            {
                path: ':fid/audit/',
                name: 'FornitoreAudit',
                component: FornitoreAudit,
                props: true
            }
        ],
    },
]

export default fornitoriRoutes
